module.exports = __webpack_public_path__ + "static/img/5.e20fc99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/zh/5.png
// module id = DOJC
// module chunks = 0